/**
 * Discovr chart palette — Tailwind hex values, no CSS vars.
 * Single source of truth for all recharts/ChartContainer color usage.
 *
 * Mapping (Tailwind name → hex):
 *   C1 indigo-500  #6366F1  — primary series (reach, main KPI)
 *   C2 emerald-500 #10B981  — positive / growth series
 *   C3 sky-500     #0EA5E9  — secondary metric (views, likes)
 *   C4 amber-500   #F59E0B  — warning / caution data
 *   C5 violet-500  #8B5CF6  — AI / sentiment series
 */
export const CHART_COLORS = {
  C1: '#6366F1', // indigo-500
  C2: '#10B981', // emerald-500
  C3: '#0EA5E9', // sky-500
  C4: '#F59E0B', // amber-500
  C5: '#8B5CF6', // violet-500
} as const;

/** Ordered palette array — use `CHART_PALETTE[index % CHART_PALETTE.length]` for N-series charts */
export const CHART_PALETTE = [
  CHART_COLORS.C1,
  CHART_COLORS.C2,
  CHART_COLORS.C3,
  CHART_COLORS.C4,
  CHART_COLORS.C5,
] as const;
